import React from 'react';
import { AppRouter } from './AppRouter';
import { ActivityProvider } from './contexts/ActivityContext';
import { TagsProvider } from './contexts/TagsContext';
import { AppDataProvider } from './contexts/AppDataContext';
import { TaskProvider } from './contexts/TaskContext';
export function App() {
  return <AppDataProvider data-id="element-0">
      <TaskProvider data-id="element-1">
        <ActivityProvider data-id="element-2">
          <TagsProvider data-id="element-3">
            <AppRouter data-id="element-4" />
          </TagsProvider>
        </ActivityProvider>
      </TaskProvider>
    </AppDataProvider>;
}